const checkPermission = (list, permission, block) => {
  if (block) {
    return list.some(widget => widget.allowed)
  } else {
    const widget = list.find(el => el.widget === permission)
    return widget ? widget.allowed : false
  }
}

const Can = ({ list, permission, block, children }) => (checkPermission(list, permission, block) ? children : null)

export default Can
